__turbopack_context__.v({
  "primary": "index-module-scss-module__EIbgFa__primary",
});
